import React, { useState, useEffect, Fragment } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory,
  Redirect,
  useLocation,
  useParams,
} from "react-router-dom";
import "./index.scss";
import { useSelector, useDispatch } from "react-redux";
import { useGetUserDataQuery } from "../../services/login";
import { useFetchQuery } from "../../services/cart";
import { useGetShippingAddressesQuery } from "../../services/login";
import { useCreateCheckoutMutation } from "../../services/checkout";
import Host from "../../Components/Host";
import { useTranslation } from "react-i18next";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import CircularProgress from "@mui/material/CircularProgress";
import Loader from "../../Components/Loader";
import { Modal } from "react-bootstrap";
import IconButton from "@mui/joy/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import FooterText from "../../Components/CheckoutComponent/FooterText";
import GuestShippingAddress from "../../Components/CheckoutComponent/GuestShippingAddress";
import ShippingAddress from "../../Components/CheckoutComponent/ShippingAddress";
import CartItems from "../../Components/CheckoutComponent/CartItems";
import CartIInformation from "../../Components/CheckoutComponent/CartIInformation";
import RazerPay from "../../Components/CheckoutComponent/RazerPay";
import ConfirmCheckout from "../../Components/CheckoutComponent/ConfirmCheckout";
import ZiinaApplePay from "../../Components/CheckoutComponent/ZiinaApplePay";

const allINRCurrency = ["INR"];
const allCurrencies = ["SAR", "BHD", "GBP", "KWD", "OMR", "QAR", "AED", "INR"];

function CheckoutPage() {
  const {
    userId,
    userToken,
    userEmail,
    userName,
    countryCode,
    cartToken,
    languageCode,
    guestShippment,
    guestPayment,
    isPurchase,
  } = useSelector((state) => state.auth);
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const tapId = new URLSearchParams(location.search).get("tap_id") || null;
  const orderId = new URLSearchParams(location.search).get("order_id") || null;
  const orderToken = new URLSearchParams(location.search).get("order_token") || null;
  const couponCode = new URLSearchParams(location.search).get("coupon") || null;
  const userParams = { userId: userId, userToken: userToken, countryCode: countryCode };
  const [getSelectShipmentAddressId, setSelectShipmentAddressId] = React.useState();
  const ShippingInfo = useGetShippingAddressesQuery(userParams, { refetchOnMountOrArgChange: true, skip: !userId });
  const ShippingData = ShippingInfo?.data?.shipping_addresses;
  const selectedShipping = ShippingData?.find((s) => s.id === getSelectShipmentAddressId);
  const { data: userData } = useGetUserDataQuery(userParams, { refetchOnMountOrArgChange: true });
  const currency = userData?.contant?.currency;
  const {
    data: cartInfo,
    isLoading,
    isFetching,
    refetch,
  } = useFetchQuery({ coupon: couponCode, cartToken: cartToken, ...userParams }, { refetchOnMountOrArgChange: true });
  const cartData = cartInfo?.cart;
  const thisToken = cartInfo?.token;
  const couponData = cartInfo?.coupon;

  const [isAddressModal, setAddressModal] = useState(false);

  const [getTestLoading, setTestLoading] = useState(false);
  const [checkoutData, setCheckoutData] = React.useState({});
  const [getCardCheckoutData, cardCheckoutData] = React.useState({});

  const [isRazerPaySelected, setRazerPaySelected] = React.useState(false);
  const [isRazerPaySelected2, setRazerPaySelected2] = React.useState(false);

  const [isZiinaApplePaySelected, setZiinaApplePaySelected] = React.useState(false);
  const [isZiinaApplePaySelected2, setZiinaApplePaySelected2] = React.useState(false);

  const [getPayByIframe, setPayByIframe] = React.useState(false);
  const [getIframeMessage, setIframeMessage] = React.useState("");

  function closePayByIframe() {
    setPayByIframe(false);
  }

  // call checkout action
  const [createcheckout, checkoutResult] = useCreateCheckoutMutation();
  const [isShippingAddress, setShippingAddress] = useState({});

  useEffect(() => {
    if (checkoutResult?.isSuccess) {
      setTestLoading(true);

      const responseData = checkoutResult?.data?.data;
      const tokenUrl =
        responseData?.transaction?.url ||
        responseData?.body?.interActionParams?.tokenUrl ||
        responseData?.redirect_url ||
        responseData?.checkout_url ||
        responseData?.Data?.PaymentURL;

      if (checkoutData?.payment_by === "razerpay_checkout") {
        try {
          // 2. Configure Razorpay options
          const options = {
            key: process.env.REACT_APP_TAP_PUBLIC_KEY_RAZER, // your Razorpay Key ID
            amount: responseData?.amount,
            currency: responseData?.currency,
            name: "The Global Genie",
            description: "Order Transaction",
            order_id: responseData?.id,
            handler: async (response) => {
              // 3. Send back payment info to verify on backend
              await fetch(
                `${process.env.REACT_APP_API_CONNECT}/api/v1/checkout/confirm/${responseData?.id}?order_id=${responseData?.receipt}&order_token=${responseData?.cartToken}`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    "X-Country-Code": countryCode,
                    "X-User-Token": userToken,
                    "X-User-Id": userId,
                    Accept: "application/json",
                  },
                  body: JSON.stringify(response),
                }
              )
                .then((res) => res.json())
                .then((data) => {
                  if (data?.status) {
                    history.push(
                      `${window.location.pathname}?order_id=${responseData?.receipt}&order_token=${responseData?.cartToken}`
                    );
                  } else {
                    alert("Payment verification failed");
                  }
                });
            },

            prefill: {
              name: isShippingAddress?.name || "",
              email: isShippingAddress?.email || "",
              contact: isShippingAddress?.phone || "",
            },
            theme: { color: "#3399cc" },
          };

          // 4. Open checkout
          const rzp = new window.Razorpay(options);
          rzp.open();
        } catch (error) {
          setIframeMessage(error);
        }
      } else {
        window.location.href = tokenUrl;
      }

      setTestLoading(false);
    }
    if (checkoutResult?.isError) {
      setPayByIframe(false);
      setTestLoading(false);
    }
  }, [checkoutResult, checkoutResult?.isSuccess, getTestLoading]);

  useEffect(() => {
    if (guestShippment?.name) {
      refetch();
    }
    if (selectedShipping?.name) {
      refetch();
    }
  }, [guestShippment, ShippingInfo]);

  const TotalPrice = cartData?.reduce((accumulator, value) => {
    const productPrice = value.prices?.value * value.quantity;
    return accumulator + productPrice;
  }, 0);

  // checkout payload
  const userInformation =
    userId && userToken
      ? {
          userId: userId,
          userToken: userToken,
          userEmail: userEmail,
          customer_name: selectedShipping?.name,
          customer_email: userEmail,
          payment_mode: "user",
          customer_phone: selectedShipping?.phone,
        }
      : {
          customer_name: guestShippment?.name,
          customer_email: guestShippment?.email,
          userEmail: guestShippment?.email,
          payment_mode: "guest",
          customer_phone: guestShippment?.phone,
        };

  useEffect(() => {
    if (selectedShipping?.name) {
      setShippingAddress({
        address: selectedShipping?.address,
        city: selectedShipping?.city,
        city_code: selectedShipping?.city_code,
        country: selectedShipping?.country,
        country_code: selectedShipping?.country_code,
        email: selectedShipping?.email,
        name: selectedShipping?.name,
        phone: selectedShipping?.phone,
        street: selectedShipping?.street,
        zip_code: selectedShipping?.zip_code,
      });
    } else {
      setShippingAddress({
        address: guestShippment?.address,
        city: guestShippment?.city,
        city_code: guestShippment?.city_code,
        country: guestShippment?.country,
        country_code: guestShippment?.country_code,
        email: guestShippment?.email,
        name: guestShippment?.name,
        phone: guestShippment?.phone,
        street: guestShippment?.street,
        zip_code: guestShippment?.zip_code,
      });
    }
  }, [selectedShipping?.name, guestShippment?.name, isShippingAddress?.name]);

  const phoneNumber = userInformation?.customer_phone || "";
  const parsedNumber = parsePhoneNumberFromString(phoneNumber);
  const countryPhoneCode = parsedNumber?.countryCallingCode;
  const countryPhoneNumber = parsedNumber?.nationalNumber;

  const checkoutPayload = {
    shipping_address: isShippingAddress,
    shipping_address_id: getSelectShipmentAddressId,
    language: languageCode,
    country: countryCode,
    countryCode: countryCode,
    currency: cartData?.[0]?.prices?.currency,
    amount: couponData ? Number(TotalPrice) - Number(couponData?.discount) : Number(TotalPrice),
    shipping_price: Number(userData?.contant?.standard_delivery),
    delivery_days: Number(userData?.contant?.delivery_days),
    products: cartData,
    cartToken: cartToken,
    domainName: Host?.domainName,
    domain: window.location.hostname,
    domainEmail: Host?.email,
    token: thisToken,
    coupon: couponData ? couponData : null,
    payment_by: checkoutData?.payment_by,
    tabby_id: checkoutData?.tabby_id,
    card_id: checkoutData?.card_id,
    customer_id: checkoutData?.customer_id,
    countryPhoneCode: countryPhoneCode,
    countryPhoneNumber: countryPhoneNumber,
    customer: userData?.user?.customer,
    data: getCardCheckoutData?.id ? getCardCheckoutData : { id: checkoutData?.tabby_id },
    ...userInformation,
  };

  const isShipmentAddress =
    userId && userToken ? (getSelectShipmentAddressId ? false : true) : guestShippment?.email ? false : true;

  // Tap card sdk checkout and checkout button action
  const proceedeToCheckout = async () => {
    if (!isShippingAddress?.name) {
      return setAddressModal(true);
    } else if (isShipmentAddress) {
      return setAddressModal(true);
    }

    const ItemsDataNitro = cartData?.map((item) => ({
      product_id: item?.product_id,
      price: Number(item?.prices?.value),
    }));
    if (countryCode === "IN") {
      if (window.nitro && typeof window.nitro.checkout === "function") {
        window.nitro.checkout({
          items: ItemsDataNitro,
        });
      } else {
        console.log("Nitro script not loaded");
      }
    }

    if (isRazerPaySelected) {
      createcheckout(checkoutPayload);
    }
    if (isRazerPaySelected2) {
      createcheckout(checkoutPayload);
    }
    if (isZiinaApplePaySelected) {
      createcheckout(checkoutPayload);
    }
    if (isZiinaApplePaySelected2) {
      createcheckout(checkoutPayload);
    }
  };

  function checkoutWithRazerPay(data) {
    refetch();
    setCheckoutData(data);
    setRazerPaySelected(data.selected);
    setRazerPaySelected2(false);
    setZiinaApplePaySelected(false);
    setZiinaApplePaySelected2(false);
  }

  function checkoutWithRazerPay2(data) {
    refetch();
    setCheckoutData(data);
    setRazerPaySelected2(data.selected);
    setRazerPaySelected(false);
    setZiinaApplePaySelected(false);
    setZiinaApplePaySelected2(false);
  }

  function checkoutWithZiinaApple(data) {
    refetch();
    setCheckoutData(data);
    setZiinaApplePaySelected(data.selected);
    setZiinaApplePaySelected2(false);
    setRazerPaySelected2(false);
    setRazerPaySelected(false);
  }

  function checkoutWithZiinaApple2(data) {
    refetch();
    setCheckoutData(data);
    setZiinaApplePaySelected2(data.selected);
    setZiinaApplePaySelected(false);
    setRazerPaySelected2(false);
    setRazerPaySelected(false);
  }

  useEffect(() => {
    if (allCurrencies?.includes(currency)) {
      if (!isZiinaApplePaySelected && !isZiinaApplePaySelected2) {
        refetch();
        setCheckoutData({ selected: true, payment_by: "ziina_payment" });
        setZiinaApplePaySelected2(true);
      }
    }
    if (allINRCurrency?.includes(currency)) {
      if (!isRazerPaySelected && !isRazerPaySelected2) {
        refetch();
        setCheckoutData({ selected: true, payment_by: "razerpay_checkout" });
        setRazerPaySelected2(true);
      }
    }
  }, [isZiinaApplePaySelected, isZiinaApplePaySelected2, isRazerPaySelected, isRazerPaySelected2]);

  function processingLoading(loading, loading2) {
    if (loading) {
      return true;
    } else if (loading2) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <div className="Purchase-page">
      <div className="container purchase-container">
        <div className="row purchase-section" style={{ position: "relative" }}>
          {orderId && orderToken && <ConfirmCheckout tapId={tapId} orderId={orderId} orderToken={orderToken} />}

          {!orderId && !orderToken && (
            <>
              {processingLoading(getTestLoading, checkoutResult?.isLoading) && (
                <div
                  style={{
                    position: "absolute",
                    right: 0,
                    left: 0,
                    top: 0,
                    zIndex: 999,
                    display: "flex",
                    justifyContent: "center",
                    height: "100%",
                    background: "#ffffffab",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <div style={{ marginBottom: "10px", color: "#000", display: "flex", alignItems: "center" }}>
                      Processing please wait!
                    </div>
                    <CircularProgress style={{ width: "2rem", height: "2rem", color: "#000" }} />
                  </div>
                </div>
              )}

              <div className="col-md-6 p0">
                <div className="row">
                  {!userId && !userToken && (
                    <GuestShippingAddress isAddressModal={isAddressModal} setAddressModal={setAddressModal} />
                  )}
                  {userId && userToken && (
                    <ShippingAddress
                      isAddressModal={isAddressModal}
                      ShippingInfo={ShippingInfo}
                      getSelectShipmentAddressId={getSelectShipmentAddressId}
                      setSelectShipmentAddressId={setSelectShipmentAddressId}
                      setAddressModal={setAddressModal}
                    />
                  )}
                  {cartData?.length > 0 && (
                    <div className="col-md-12 pp-padding">
                      <div className="cp-cinfo-card">
                        <div style={{ marginBottom: "15px" }}>
                          <span className="alert alert-info alert-text">{t("select_payment_method")}</span>
                        </div>

                        {/* {allINRCurrency?.includes(currency) && (
                          <RazerPay
                            isShipmentAddress={isShipmentAddress}
                            isRazerPaySelected={isRazerPaySelected}
                            isRazerPaySelected2={isRazerPaySelected2}
                            checkoutWithRazerPay={checkoutWithRazerPay}
                            checkoutWithRazerPay2={checkoutWithRazerPay2}
                          />
                        )} */}

                        {allCurrencies?.includes(currency) && (
                          <ZiinaApplePay
                            isShipmentAddress={isShipmentAddress}
                            isZiinaApplePaySelected={isZiinaApplePaySelected}
                            isZiinaApplePaySelected2={isZiinaApplePaySelected2}
                            checkoutWithZiinaApple={checkoutWithZiinaApple}
                            checkoutWithZiinaApple2={checkoutWithZiinaApple2}
                            setAddressModal={setAddressModal}
                          />
                        )}

                        <Modal
                          className="pay-purchase-dialogue"
                          show={getPayByIframe}
                          onHide={closePayByIframe}
                          centered
                          animation={false}
                        >
                          <Modal.Body>
                            <IconButton
                              style={{ cursor: "pointer", position: "absolute", right: "5px", top: "5px", zIndex: 111 }}
                              onClick={closePayByIframe}
                            >
                              <CloseIcon className="Header-close-modal-icon" />
                            </IconButton>
                            {checkoutResult?.isLoading && (
                              <div
                                style={{
                                  height: "450px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <CircularProgress style={{ width: "2rem", height: "2rem", color: "#000" }} />
                              </div>
                            )}

                            {getIframeMessage && (
                              <div
                                className="alert alert-danger"
                                style={{ background: "#fff0", border: "none", margin: 0, padding: "20px" }}
                              >
                                {getIframeMessage}
                              </div>
                            )}
                            {checkoutResult?.isSuccess && (
                              <div style={{ height: "500px" }} id="container-checkout-test"></div>
                            )}
                          </Modal.Body>
                        </Modal>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-5 pp-padding">
                <div className="row">
                  <div className="col-md-12 pp-padding">
                    <div className="cp-cinfo-card " style={{ marginBottom: "10px" }}>
                      <CartItems
                        isLoading={isLoading}
                        isFetching={isFetching}
                        cartData={cartData}
                        userData={userData}
                        checkoutResult={checkoutResult}
                      />

                      <CartIInformation
                        isLoading={isLoading}
                        isFetching={isFetching}
                        cartData={cartData}
                        userData={userData}
                        proceedeToCheckout={proceedeToCheckout}
                        couponData={couponData}
                        isRazerPaySelected={isRazerPaySelected}
                        isRazerPaySelected2={isRazerPaySelected2}
                        isZiinaApplePaySelected={isZiinaApplePaySelected}
                        isZiinaApplePaySelected2={isZiinaApplePaySelected2}
                        getSelectShipmentAddressId={getSelectShipmentAddressId}
                        checkoutResult={checkoutResult}
                      />
                    </div>
                  </div>
                  <FooterText />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <br />
      <br />
    </div>
  );
}

export default CheckoutPage;
